import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MessageFilter from '../components/filters/message-filter';
import MessagesTable from '../components/tables/messages-table';

const MessagesListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="پیام ها"
      style={{ padding: " 16px 0" }}
      extra={[
        <Button key="add"><Link to="/messages-form">افزودن</Link></Button>,
      ]}
      onBack={() => navigate(-1)}
    />
    <MessageFilter onFinish={setFitlers} />
    <MessagesTable  filters={filters} />
  </>);
}

export default MessagesListRoute;
